// source: pbtypes/gen/scan_planner/surface_scan_request.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_eigen_lcm_Vector3d_pb = require('../../../pbtypes/gen/eigen_lcm/Vector3d_pb.js');
goog.object.extend(proto, pbtypes_gen_eigen_lcm_Vector3d_pb);
var pbtypes_gen_scan_output_scan_coverage_parameters_pb = require('../../../pbtypes/gen/scan_output/scan_coverage_parameters_pb.js');
goog.object.extend(proto, pbtypes_gen_scan_output_scan_coverage_parameters_pb);
goog.exportSymbol('proto.scan_planner.SurfaceScanRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.scan_planner.SurfaceScanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.scan_planner.SurfaceScanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.scan_planner.SurfaceScanRequest.displayName = 'proto.scan_planner.SurfaceScanRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.scan_planner.SurfaceScanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.scan_planner.SurfaceScanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.scan_planner.SurfaceScanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.SurfaceScanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
cropFraction: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
coverPointsUsingWaypointPose: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
numMeshPoints: jspb.Message.getFieldWithDefault(msg, 5, 0),
scanCoverageParameters: (f = msg.getScanCoverageParameters()) && pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.toObject(includeInstance, f),
overrideLookat: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
globalMapTLookat: (f = msg.getGlobalMapTLookat()) && pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.scan_planner.SurfaceScanRequest}
 */
proto.scan_planner.SurfaceScanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.scan_planner.SurfaceScanRequest;
  return proto.scan_planner.SurfaceScanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.scan_planner.SurfaceScanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.scan_planner.SurfaceScanRequest}
 */
proto.scan_planner.SurfaceScanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setCropFraction(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCoverPointsUsingWaypointPose(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setNumMeshPoints(value);
      break;
    case 6:
      var value = new pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters;
      reader.readMessage(value,pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.deserializeBinaryFromReader);
      msg.setScanCoverageParameters(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOverrideLookat(value);
      break;
    case 8:
      var value = new pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb;
      reader.readMessage(value,pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.deserializeBinaryFromReader);
      msg.setGlobalMapTLookat(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.scan_planner.SurfaceScanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.scan_planner.SurfaceScanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.scan_planner.SurfaceScanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.scan_planner.SurfaceScanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCropFraction();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getCoverPointsUsingWaypointPose();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getNumMeshPoints();
  if (f !== 0) {
    writer.writeSint64(
      5,
      f
    );
  }
  f = message.getScanCoverageParameters();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters.serializeBinaryToWriter
    );
  }
  f = message.getOverrideLookat();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getGlobalMapTLookat();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb.serializeBinaryToWriter
    );
  }
};


/**
 * optional float crop_fraction = 1;
 * @return {number}
 */
proto.scan_planner.SurfaceScanRequest.prototype.getCropFraction = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.SurfaceScanRequest} returns this
 */
proto.scan_planner.SurfaceScanRequest.prototype.setCropFraction = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional bool cover_points_using_waypoint_pose = 4;
 * @return {boolean}
 */
proto.scan_planner.SurfaceScanRequest.prototype.getCoverPointsUsingWaypointPose = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.SurfaceScanRequest} returns this
 */
proto.scan_planner.SurfaceScanRequest.prototype.setCoverPointsUsingWaypointPose = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional sint64 num_mesh_points = 5;
 * @return {number}
 */
proto.scan_planner.SurfaceScanRequest.prototype.getNumMeshPoints = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.scan_planner.SurfaceScanRequest} returns this
 */
proto.scan_planner.SurfaceScanRequest.prototype.setNumMeshPoints = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional scan_output.ScanCoverageParameters scan_coverage_parameters = 6;
 * @return {?proto.scan_output.ScanCoverageParameters}
 */
proto.scan_planner.SurfaceScanRequest.prototype.getScanCoverageParameters = function() {
  return /** @type{?proto.scan_output.ScanCoverageParameters} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_scan_output_scan_coverage_parameters_pb.ScanCoverageParameters, 6));
};


/**
 * @param {?proto.scan_output.ScanCoverageParameters|undefined} value
 * @return {!proto.scan_planner.SurfaceScanRequest} returns this
*/
proto.scan_planner.SurfaceScanRequest.prototype.setScanCoverageParameters = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.SurfaceScanRequest} returns this
 */
proto.scan_planner.SurfaceScanRequest.prototype.clearScanCoverageParameters = function() {
  return this.setScanCoverageParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.SurfaceScanRequest.prototype.hasScanCoverageParameters = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool override_lookat = 7;
 * @return {boolean}
 */
proto.scan_planner.SurfaceScanRequest.prototype.getOverrideLookat = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.scan_planner.SurfaceScanRequest} returns this
 */
proto.scan_planner.SurfaceScanRequest.prototype.setOverrideLookat = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional eigen_lcm.Vector3dPb global_map_t_lookat = 8;
 * @return {?proto.eigen_lcm.Vector3dPb}
 */
proto.scan_planner.SurfaceScanRequest.prototype.getGlobalMapTLookat = function() {
  return /** @type{?proto.eigen_lcm.Vector3dPb} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_eigen_lcm_Vector3d_pb.Vector3dPb, 8));
};


/**
 * @param {?proto.eigen_lcm.Vector3dPb|undefined} value
 * @return {!proto.scan_planner.SurfaceScanRequest} returns this
*/
proto.scan_planner.SurfaceScanRequest.prototype.setGlobalMapTLookat = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.scan_planner.SurfaceScanRequest} returns this
 */
proto.scan_planner.SurfaceScanRequest.prototype.clearGlobalMapTLookat = function() {
  return this.setGlobalMapTLookat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.scan_planner.SurfaceScanRequest.prototype.hasGlobalMapTLookat = function() {
  return jspb.Message.getField(this, 8) != null;
};


goog.object.extend(exports, proto.scan_planner);
